import React, { useEffect } from "react";
import { useAdminState } from "../contexts/AdminContext";
import * as API from "../api/request";
import Swal from "sweetalert2";

const Category = () => {
  const { admin, setAdmin } = useAdminState();

  useEffect(() => {
    API.getCategory()
      .then((res) => setAdmin({ type: "CATEGORY_LIST", data: res }))
      .catch(() => {
        Swal.fire("Анхаар", "Жагсаалт татаж чадсангүй!", "warning");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [admin.category.refresh]);

  const save = () => {
    if (admin.category.category_name && admin.category.category_short) {
      API.postputCategory(admin.category.id, {
        category_name: admin.category.category_name,
        category_short: admin.category.category_short,
      })
        .then(() => {
          setAdmin({ type: "CATEGORY_REFRESH" });
          Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
        })
        .catch(() => {
          Swal.fire(
            "Анхаар",
            "Бүртгэж чадсангүй дахин оролдоно уу!",
            "warning"
          );
        });
    } else {
      Swal.fire("Анхаар", "Талбаруудыг бүрэн бөглөнө үү.", "warning");
    }
  };

  const trash = (id) => {
    Swal.fire({
      title: "Та устгахдаа итгэлтэй байна уу?",
      text: "Сэргэх боломжгүйг анхаарна уу!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Тийм",
      cancelButtonText: "Үгүй",
    }).then((result) => {
      if (result.isConfirmed) {
        API.deleteCategory(id)
          .then(() => {
            setAdmin({ type: "CATEGORY_REFRESH" });
            Swal.fire("Амжилттай", "Амжилттай устгалаа.", "success");
          })
          .catch(() => {
            Swal.fire(
              "Анхаар",
              "Устгаж чадсангүй дахин оролдоно уу!",
              "warning"
            );
          });
      }
    });
  };

  return (
    <div className={admin.category.modal ? "block" : "hidden"}>
      <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 w-full h-modal h-full bg-black opacity-30 z-[61]"></div>
      <div
        className="fixed top-1/2 left-1/2 w-full max-w-[800px] h-auto z-[62]"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex justify-between items-center px-4 py-2 rounded-t border-b">
            <div className="font-semibold text-gray-900">Бүлэг</div>
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
              data-modal-toggle="defaultModal"
              onClick={() => setAdmin({ type: "CATEGORY_MODAL", data: false })}
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div className="p-4">
            {/* body */}
            <div className="relative max-h-[calc(100vh-145px)] overflow-auto">
              <div className="flex items-start justify-center gap-2">
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none"
                  maxLength={500}
                  placeholder="Товч нэр бичнэ үү"
                  value={admin.category.category_short}
                  onChange={(e) =>
                    setAdmin({
                      type: "CATEGORY_CHANGE",
                      data: {
                        category_short: e.target.value,
                      },
                    })
                  }
                />
                <textarea
                  rows="4"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none"
                  placeholder="Дэлгэрэнгүй нэр бичнэ үү"
                  value={admin.category.category_name}
                  onChange={(e) =>
                    setAdmin({
                      type: "CATEGORY_CHANGE",
                      data: {
                        category_name: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <div className="flex items-center justify-center mt-2">
                <button
                  className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300"
                  onClick={() => save()}
                >
                  Хадгалах
                </button>
              </div>
              <br />
              <div className="overflow-auto">
                <table className="min-w-full">
                  <thead className="border-b">
                    <tr className="bg-gray-100">
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px]"
                      >
                        №
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Товч
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Дэлгэрэнгүй
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px]"
                      >
                        #
                      </th>
                    </tr>
                  </thead>
                  <tbody className="h-[50px] max-h-[50px] overflow-auto">
                    {admin.category.list.length > 0 ? (
                      admin.category.list.map((el, index) => {
                        return (
                          <tr className="border-b" key={el.id}>
                            <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center w-[50px]">
                              {index + 1}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2">
                              {el.category_short}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2">
                              {el.category_name}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-2 py-2 whitespace-nowrap text-center w-[50px]">
                              <i
                                className="fa fa-edit text-blue-700 cursor-pointer mr-2"
                                onClick={() => {
                                  setAdmin({
                                    type: "CATEGORY_EDIT_FORM",
                                    id: el.id,
                                    category_name: el.category_name,
                                    category_short: el.category_short,
                                  });
                                }}
                              />
                              <i
                                className="fa fa-trash text-red-700 cursor-pointer"
                                onClick={() => trash(el.id)}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="border-b">
                        <td
                          className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center"
                          colSpan={3}
                        >
                          Хоосон байна
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* body */}
            <hr className="-mx-4 my-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Category);
